import { useVerandaSelector } from '../../../../..'
import { useMeasures } from '../../../../../hooks/state/useMeasures'
import { useRoof } from '../../../../../hooks/state/useRoof'
import { useSidewall } from '../../../../../hooks/state/useSidewall'
import { CachedMeshPhysicalMaterial } from '../../../../material/cachedMeshPhysicalMaterial'
import { RoundedBox } from '@react-three/drei'
import { SideTie } from '../../window/side/tie/SideTie'
import { Helper } from '../../../../../classes/helper'
import { Keys } from '../../../../../hooks/state/utlility/utils'
import { Shape } from 'three'

interface Props {
  outside: boolean
  isQubus: boolean
}

export const MarqueeRoundBox = ({
  outside,
  isQubus = false,
}: Props): JSX.Element => {
  const { spaceBetween, verticalMarqueeAttr, verticalMarqueeMetalColor } =
    useSidewall()

  const radius = verticalMarqueeAttr.height / 2
  const shape = new Shape()
  shape.absarc(0, 0, radius, 0, Math.PI * 2, false)

  const extrudeSettings = {
    curveSegments: 32,
    steps: 1,
    depth: spaceBetween,
    bevelEnabled: false,
  }

  return (
    <group dispose={null} castShadow receiveShadow position={[0, 0, 0]}>
      <mesh
        rotation={[0, 0, 0]}
        position={[0, 0, -spaceBetween / 2]}
        castShadow={true}
        receiveShadow
      >
        <extrudeGeometry attach="geometry" args={[shape, extrudeSettings]} />
        <CachedMeshPhysicalMaterial color={verticalMarqueeMetalColor} />
      </mesh>
      <mesh>
        <RoundedBox
          args={[
            0.03,
            verticalMarqueeAttr.height,
            verticalMarqueeAttr.width - 0.0002,
          ]}
          position={[verticalMarqueeAttr.depth / 2 - 0.015, -0.01, 0]}
          radius={0.0005}
          smoothness={0.5}
          castShadow={true}
          matrixWorldAutoUpdate={undefined}
          getObjectsByProperty={undefined}
          getVertexPosition={undefined}
        >
          <CachedMeshPhysicalMaterial
            color={verticalMarqueeMetalColor}
            metalness={0.2}
          />
        </RoundedBox>
        <RoundedBox
          args={[
            verticalMarqueeAttr.depth / 2,
            0.02,
            verticalMarqueeAttr.width - 0.0002,
          ]}
          position={[
            verticalMarqueeAttr.depth / 4,
            verticalMarqueeAttr.height / 2 - 0.01,
            0,
          ]}
          radius={0.0005}
          smoothness={0.5}
          castShadow={true}
          matrixWorldAutoUpdate={undefined}
          getObjectsByProperty={undefined}
          getVertexPosition={undefined}
        >
          <CachedMeshPhysicalMaterial
            color={verticalMarqueeMetalColor}
            metalness={0.2}
          />
        </RoundedBox>
      </mesh>
    </group>
  )
}
